import { render, staticRenderFns } from "./add-new-focus-topic.vue?vue&type=template&id=b7fcf326"
import script from "./add-new-focus-topic.ts?vue&type=script&lang=ts&external"
export * from "./add-new-focus-topic.ts?vue&type=script&lang=ts&external"
import style0 from "./add-new-focus-topic.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7fcf326')) {
      api.createRecord('b7fcf326', component.options)
    } else {
      api.reload('b7fcf326', component.options)
    }
    module.hot.accept("./add-new-focus-topic.vue?vue&type=template&id=b7fcf326", function () {
      api.rerender('b7fcf326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/focus-topics/add-new-focus-topic/add-new-focus-topic.vue"
export default component.exports